
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mfaiJZI6q0XTJDAY2Mu3wgrPZ8lIIkNPfvvhIjCzmom_ZMMeta } from "/home/vsts/work/1/s/pages/mfa.vue?macro=true";
import { default as homeisMk_45QriQVi8fadhACBDBK_45zKVSBVdGbYKS9msfXrMgMeta } from "/home/vsts/work/1/s/pages/home.vue?macro=true";
import { default as indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta } from "/home/vsts/work/1/s/pages/index.vue?macro=true";
import { default as oldKtBJCFS8KyzI64HknfSB_GyE0qnyuYS_45WWPJnPLIqUUMeta } from "/home/vsts/work/1/s/pages/test/old.vue?macro=true";
import { default as draweBFW5BpFSCxdHdkkVMhZdfYwHv5peYku_uvR5tlQ3gIMeta } from "/home/vsts/work/1/s/pages/test/draw.vue?macro=true";
import { default as i18nP73rgro41f0xUJTOSgwNn9snz5JivGpYg0gHvbxmc7UMeta } from "/home/vsts/work/1/s/pages/test/i18n.vue?macro=true";
import { default as indexoZ2VNxugBD6D5ypK8p0sqXMj4wZd1Y9IodFYZq9ZoAIMeta } from "/home/vsts/work/1/s/pages/test/index.vue?macro=true";
import { default as actionsWNKymns_2Swo3c4WYo05WR100JkGUqcNdfILc6xklZMMeta } from "/home/vsts/work/1/s/pages/test/actions.vue?macro=true";
import { default as Address8lAC9UNNbcUxKlbsgv6UbXhyOdEAkfDXF0tQATcz5KgMeta } from "/home/vsts/work/1/s/pages/test/Address.vue?macro=true";
import { default as expenseTWZNKDGGwZbrwNTMmbZwoKAMuE_rfqL_45NlK_45XGhQOOIMeta } from "/home/vsts/work/1/s/pages/test/expense.vue?macro=true";
import { default as indexyg8cuFnJ_45YzXRw7019UQksnOH55J8Iet7P223VsUAdYMeta } from "/home/vsts/work/1/s/pages/calendar/index.vue?macro=true";
import { default as indexCoPUhkl_45iWHTMsvE2Rk0zAPsJqrrXPcjoGHt1sSAU1QMeta } from "/home/vsts/work/1/s/pages/expenses/index.vue?macro=true";
import { default as materialsYdibr3_nSsaG49dhyTFxKFy_45GvalF_45UDtoOgL_RQtbgMeta } from "/home/vsts/work/1/s/pages/test/materials.vue?macro=true";
import { default as fileUploadCVRnli9ktJXEf2AaAL1bS5eMXXL8fMgstBaBVRvmTfEMeta } from "/home/vsts/work/1/s/pages/test/fileUpload.vue?macro=true";
import { default as composablesGy2Y1htj5c0qr_45pPks5d_QL61MR_F6tSHhnETXlcqj4Meta } from "/home/vsts/work/1/s/pages/test/composables.vue?macro=true";
import { default as index2qqVgfpDrSJRvjK_45HrWK8F0KQVDehdvZWFWRttgR5o0Meta } from "/home/vsts/work/1/s/pages/worksheets/index.vue?macro=true";
import { default as valid_45inputs4hJUaD7DArnssNML652d1rpUyGadLRQJ4K39OaCrkpsMeta } from "/home/vsts/work/1/s/pages/test/valid-inputs.vue?macro=true";
import { default as generic_45selectsLi4bRZWrothFpLLGqzIPhVi5Hu_452s2t9oQDNHGhB6U0Meta } from "/home/vsts/work/1/s/pages/test/generic-selects.vue?macro=true";
import { default as hourRegistrationxRnAAgiDsJKmfIyq9ZJBlcP_45MlDZnadeML60C8CabHwMeta } from "/home/vsts/work/1/s/pages/test/hourRegistration.vue?macro=true";
import { default as MaterialLocationL9keCR2pnkrKnqyGQVQQz51ZlHtVleVaegmyDl7_459jQMeta } from "/home/vsts/work/1/s/pages/test/MaterialLocation.vue?macro=true";
import { default as NativeFileUpload8E5DI4fqmpn7787v2JV32tg_LTkQK6dlaByat7lCDR0Meta } from "/home/vsts/work/1/s/pages/test/NativeFileUpload.vue?macro=true";
import { default as indexESFER8sbR2RVeRs3mI474ACb4yugdu7Zvx__dntBd3YMeta } from "/home/vsts/work/1/s/pages/hourRegistrations/index.vue?macro=true";
import { default as association_45selectM94_RY07sq8dWh4KDtjZQjoJzk9EyV2vFiuB6Jx7jwwMeta } from "/home/vsts/work/1/s/pages/test/association-select.vue?macro=true";
import { default as worksheetStopwatchMxXUbAuyxQAjvyBC4a_45qqrr7k6t6q3UMCpFU1xFKTn8Meta } from "/home/vsts/work/1/s/pages/test/worksheetStopwatch.vue?macro=true";
import { default as indexAxyB5z6xTjqlXP05lu9_45z7_1xTZv578Yz6UJRGc9Ek4Meta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/index.vue?macro=true";
import { default as notesDYWN3n_45o9uaIEMv0OSZQWOuH26OOF_15Nm8S24aBPPYMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/notes.vue?macro=true";
import { default as index4GFUNZZ4fKR2z_45_Ekj2SgjhuPIAfh57aPlsRqN3itSoMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/qa/index.vue?macro=true";
import { default as _91schemaId_93bS92Ejrzh4wETQpK3HNSXt831Q3F_ajA9KxzL8NYYrAMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/qa/[schemaId].vue?macro=true";
import { default as cartQw0Uah_45OgL_45QcdZ7piBIgNqGBF_45LAlIb5FYraFsj0sUMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/cart.vue?macro=true";
import { default as rentpRe0_2L9WHMAGjLw4tqb5D91FU1vC7_X7C1Wgb_vZHgMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/rent.vue?macro=true";
import { default as indexQJVegIA2Vg1L_ha0qqmDRJVqFI3tl2gOx4Wfr3GVw8gMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/documents/index.vue?macro=true";
import { default as items6JiDihzW_gDtpAJVE_qdiwTWKo6rp4su9h6CpNwaxAMMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/items.vue?macro=true";
import { default as catalog27Qquag6yAZmDesgJNp7NvVTUAnNNnWHZrBkUh8joHwMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/catalog.vue?macro=true";
import { default as hour_45registrationseFikaZUnqbeeD9srO5zer4tTk5UhdtloObpgCafwr_8Meta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/hour-registrations.vue?macro=true";
import { default as standard_45linesB7HOhp8Mv9HvBVGpJH7wdEoEgYoEXSi3pgxZWs_45X4UEMeta } from "/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/standard-lines.vue?macro=true";
export default [
  {
    name: "mfa",
    path: "/mfa",
    component: () => import("/home/vsts/work/1/s/pages/mfa.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/vsts/work/1/s/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "test-old",
    path: "/test/old",
    component: () => import("/home/vsts/work/1/s/pages/test/old.vue")
  },
  {
    name: "test-draw",
    path: "/test/draw",
    component: () => import("/home/vsts/work/1/s/pages/test/draw.vue")
  },
  {
    name: "test-i18n",
    path: "/test/i18n",
    component: () => import("/home/vsts/work/1/s/pages/test/i18n.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/home/vsts/work/1/s/pages/test/index.vue")
  },
  {
    name: "test-actions",
    path: "/test/actions",
    component: () => import("/home/vsts/work/1/s/pages/test/actions.vue")
  },
  {
    name: "test-Address",
    path: "/test/Address",
    component: () => import("/home/vsts/work/1/s/pages/test/Address.vue")
  },
  {
    name: "test-expense",
    path: "/test/expense",
    component: () => import("/home/vsts/work/1/s/pages/test/expense.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/home/vsts/work/1/s/pages/calendar/index.vue")
  },
  {
    name: "expenses",
    path: "/expenses",
    component: () => import("/home/vsts/work/1/s/pages/expenses/index.vue")
  },
  {
    name: "test-materials",
    path: "/test/materials",
    component: () => import("/home/vsts/work/1/s/pages/test/materials.vue")
  },
  {
    name: "test-fileUpload",
    path: "/test/fileUpload",
    component: () => import("/home/vsts/work/1/s/pages/test/fileUpload.vue")
  },
  {
    name: "test-composables",
    path: "/test/composables",
    component: () => import("/home/vsts/work/1/s/pages/test/composables.vue")
  },
  {
    name: "worksheets",
    path: "/worksheets",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/index.vue")
  },
  {
    name: "test-valid-inputs",
    path: "/test/valid-inputs",
    component: () => import("/home/vsts/work/1/s/pages/test/valid-inputs.vue")
  },
  {
    name: "test-generic-selects",
    path: "/test/generic-selects",
    component: () => import("/home/vsts/work/1/s/pages/test/generic-selects.vue")
  },
  {
    name: "test-hourRegistration",
    path: "/test/hourRegistration",
    component: () => import("/home/vsts/work/1/s/pages/test/hourRegistration.vue")
  },
  {
    name: "test-MaterialLocation",
    path: "/test/MaterialLocation",
    component: () => import("/home/vsts/work/1/s/pages/test/MaterialLocation.vue")
  },
  {
    name: "test-NativeFileUpload",
    path: "/test/NativeFileUpload",
    component: () => import("/home/vsts/work/1/s/pages/test/NativeFileUpload.vue")
  },
  {
    name: "hourRegistrations",
    path: "/hourRegistrations",
    component: () => import("/home/vsts/work/1/s/pages/hourRegistrations/index.vue")
  },
  {
    name: "test-association-select",
    path: "/test/association-select",
    component: () => import("/home/vsts/work/1/s/pages/test/association-select.vue")
  },
  {
    name: "test-worksheetStopwatch",
    path: "/test/worksheetStopwatch",
    component: () => import("/home/vsts/work/1/s/pages/test/worksheetStopwatch.vue")
  },
  {
    name: "worksheets-worksheetId",
    path: "/worksheets/:worksheetId()",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/index.vue")
  },
  {
    name: "worksheets-worksheetId-notes",
    path: "/worksheets/:worksheetId()/notes",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/notes.vue")
  },
  {
    name: "worksheets-worksheetId-qa",
    path: "/worksheets/:worksheetId()/qa",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/qa/index.vue")
  },
  {
    name: "worksheets-worksheetId-qa-schemaId",
    path: "/worksheets/:worksheetId()/qa/:schemaId()",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/qa/[schemaId].vue")
  },
  {
    name: "worksheets-worksheetId-materials-cart",
    path: "/worksheets/:worksheetId()/materials/cart",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/cart.vue")
  },
  {
    name: "worksheets-worksheetId-materials-rent",
    path: "/worksheets/:worksheetId()/materials/rent",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/rent.vue")
  },
  {
    name: "worksheets-worksheetId-documents",
    path: "/worksheets/:worksheetId()/documents",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/documents/index.vue")
  },
  {
    name: "worksheets-worksheetId-materials-items",
    path: "/worksheets/:worksheetId()/materials/items",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/items.vue")
  },
  {
    name: "worksheets-worksheetId-materials-catalog",
    path: "/worksheets/:worksheetId()/materials/catalog",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/catalog.vue")
  },
  {
    name: "worksheets-worksheetId-hour-registrations",
    path: "/worksheets/:worksheetId()/hour-registrations",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/hour-registrations.vue")
  },
  {
    name: "worksheets-worksheetId-materials-standard-lines",
    path: "/worksheets/:worksheetId()/materials/standard-lines",
    component: () => import("/home/vsts/work/1/s/pages/worksheets/[worksheetId]/materials/standard-lines.vue")
  }
]